import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField";
import { characterValidation } from "../../../common/commonFunction";
import { verifyDuplicate } from "../../../common/commonAPI";

class LViewYard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            description: "",
            nameError: false,
            searchData: {
                Name: "",
                PageNumber: 1,
                PageSize: 100,
            },
            verifyText: "",
            paging: false,
            existId: [],
            isOnChange: false,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.setState({ paging: true });
        this.dataTable(this.state.searchData)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    dataTable = (data) => {
        let apiUrl = API.ACTION_YARDLOOKUP + '?Name=' + data.Name + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    response.data?.YardData?.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({
                        HoverId: 0,
                        index: 0,
                    })
                    this.state.dataList = response.data;
                    const check = this.state.dataList?.YardData.filter((data) => data.Name == "");
                    if (check?.length == 0) {
                        this.state.dataList?.YardData?.push({
                            Id: 0,
                            Name: "",
                        })
                    }
                    this.state.render = true;
                    this.setState({})
                    if (this.state.paging == true) {
                        setTimeout(
                            window.scrollTo(0, 0)
                            , 0)
                        this.setState({
                            paging: false
                        })
                    }
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MASDATA7 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData7 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#MasterData77").addClass("d-none");
        $("#MasterData77").removeClass("d-block");
        $("#MYard").removeClass("active-color");
        $("#MYardT").removeClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebarmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MASDATA7 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData7 .MuiListItemText-primary").addClass("fw-bolder");
        $("#MasterData77").removeClass("d-none");
        $("#MasterData77").addClass("d-block");
        $("#MYardT .MuiListItemText-primary").addClass("fw-bolder")
        $("#MYard").addClass("active-color");
    };

    post_data = (data) => {
        let apiUrl = API.ACTION_YARDLOOKUP;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        }).then((response) => {
            if (response?.status === 200) {
                this.state.dataList?.YardData?.map((i) => (
                    i.Id == 0 ? i.Id = response.data : <></>
                ))
                this.setState({})
                this.dataTable(this.state.searchData);
                let id = this.state.dataList?.YardData?.filter((i) => i.Id == 0)
                if (id.length == 0) {
                    this.state.dataList?.YardData?.push({
                        Id: 0,
                        Name: "",
                    })
                }
                this.state.dataList?.YardData?.sort((a, b) => {
                    return a.Id - b.Id;
                });
                this.setState({})
            } else {
            }
        })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data) => {
        let apiUrl = API.ACTION_YARDLOOKUP + '/' + data.Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData);
                    // this.state.actNameFocus = false;
                    // this.state.DescNameFocus = false;
                    // this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopupDelete = (Id) => {
        let url = API.VERIFY_LOOKUPYARD + "?id=" + Id;
        axios.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let mainText = "Unable to delete. This yard was tagged into ";
                    if (response.data?.UserYardCount == 0 && response?.data?.ProjectYardCount == 0) {
                        this.OpenPopup(Id)
                    } else if (response.data?.UserYardCount == 0 && response?.data?.ProjectYardCount != 0) {
                        let data = response?.data?.ProjectYardCount > 1 ? "s." : ".";
                        this.setState({
                            verifyText: mainText + response?.data?.ProjectYardCount + " project" + data
                        }, () => (
                            window.$("#deletepopuperror").modal("show")
                        ))
                    }
                    else if (response.data?.UserYardCount != 0 && response?.data?.ProjectYardCount == 0) {
                        let data = response.data?.UserYardCount > 1 ? "s." : ".";
                        this.setState({
                            verifyText: mainText + response.data?.UserYardCount + " user" + data
                        }, () => (
                            window.$("#deletepopuperror").modal("show")
                        ))
                    }
                    else if (response.data?.UserYardCount != 0 && response?.data?.ProjectYardCount != 0) {
                        let data = response?.data?.ProjectYardCount > 1 ? "s " : "";
                        let data1 = response.data?.UserYardCount > 1 ? "s." : "."
                        this.setState({
                            verifyText: mainText + response?.data?.ProjectYardCount + " project" + data + " and " + response.data?.UserYardCount + " user" + data1
                        }, () => (
                            window.$("#deletepopuperror").modal("show")
                        ))
                    }
                }
            })
            .catch((error) => {

            });
    }

    OpenPopup = (Id) => {
        this.state.deleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.ACTION_YARDLOOKUP + '/' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let data = {
                        Name: "",
                        PageNumber: 1,
                        PageSize: 100,
                    };
                    this.setState({
                        searchData: data,
                    })
                    this.dataTable(data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    handleInputChange1 = (e, str, val, index) => {
        this.setState({
            isOnChange : true,
        })
        if (val == "Name") {
            if (characterValidation(e.target.value) == true) {
                this.state?.dataList?.YardData?.map((i) => (
                    i.Id == str.Id ? i.Name = e.target.value : <></>
                ))
            }
        }
        this.setState({})
    }

    handlePasteChange = (event, str, val, index) => {
        let data = {
            Name: event.clipboardData.getData("text").trim(),
        }
        this.state?.dataList?.YardData?.map((i) => (
            i.Id == 0 ? i.Name.trim() == "" ? (
                this.post_data(data),
                this.state.actNameFocus = true
            )
                : "" : ""
        ))
        this.setState({})
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.state.paging = true;
        this.state.existId = [];
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.state.paging = true;
        this.state.existId = [];
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    handleInputChange = (e, str, val) => {
        if (val == "Name") {
            str.Name = e.target.value.trim();
            this.put_data(str)
        }
        this.state.dataList?.YardData?.sort((a, b) => {
            return a.Id - b.Id;
        });
        this.setState({})
    }

    postDataChange = (e, val) => {
        if (val == "Name") {
            this.state.name = e.target.value;
            if (e.target.value.trim() != "") {
                this.state.showrow = true;
            }
            if (e.target.value.trim() != "") {
                this.state.nameError = true;
            }
        }
        this.setState({})
    }

    async postDataBlur(e, str, val) {
        if (val == "Name" && this.state.isOnChange == true) {
            this.setState({
                isOnChange : false,
            })
            let dataName = e.target.value.trim();
            if (dataName != "") {
                let url = API.verifyDuplicate_Yard + dataName
                try {
                    let response = await axios.get(url);
                    if (response?.data == true) {
                        let index = this.state.existId.filter(item => item !== str.Id);
                        this.setState({
                            existId: index
                        })
                        if (str.Id == 0) {
                            let data = {
                                Id: str.Id,
                                Name: dataName,
                            }
                            this.post_data(data)
                        } else {
                            str.Name = dataName;
                            this.put_data(str)
                            this.state.dataList?.YardData?.sort((a, b) => {
                                return a.Id - b.Id;
                            });
                        }
                    } else if (response?.data == false) {
                        let data = [...this.state.existId];
                        data.push(str.Id);
                        this.setState({
                            existId: data
                        })
                    }
                } catch (e) {

                }
            } else if (e.target.value.trim() == "") {
                if (str.Id != 0) {
                    str.Name = dataName;
                    this.put_data(str)
                    this.state.dataList?.YardData?.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    let index = this.state.existId.filter(item => item !== str.Id);
                    this.setState({
                        existId: index
                    })
                }
            }
        } else if (this.state.isOnChange == false){
            this.setState({
                HoverId: 0,
                index: 0,
            })
        }
        this.setState({})
    }

    handleFocusDescription = (e, str, val) => {
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('DescName').selectionStart = e.target.value.trim().length;
            document.getElementById('DescName').focus()
        }
    }

    handleFocusDescription1 = (e, str, val) => {
        if (e.target.value.trim().length > 0) {
            document.getElementById('DescName' + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById('DescName' + str.Id).focus()
        }
    }

    handleFocusNameChange = (e, str, val) => {
        if (e.target.value.trim().length > 0) {
            document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("actName" + str.Id).focus()
        }
    }

    handleFocusActChange = (e, str, val) => {
        // if (str.Id == 0 && e.target.value.trim().length > 0) {
        //     document.getElementById('actName').selectionStart = e.target.value.trim().length;
        //     document.getElementById('actName').focus()
        // }
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="MASDATA6" className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="MASDATA66" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Yards</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Yards</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="97%" style={{ minWidth: '97%', maxWidth: '97%' }}><span className="spandoc-thead">Name</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList?.YardData && this.state?.dataList?.YardData?.length > 0 && this.state?.dataList?.YardData?.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <div className={this.state.isDisabled ? "border-bg-none" : (this.state.HoverId == i.Id || this.state.index == i.Id || i.Name == "" || this.state.existId?.includes(i.Id) == true) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id={"actName" + i.Id}
                                                                disabled={this.state.isDisabled}
                                                                onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                onFocus={(e) => this.setState({ index: i.Id })}
                                                                onChange={(e) => this.handleInputChange1(e, i, 'Name', index)}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name', index)}
                                                                value={i.Name && i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                        {(i.Name?.trim() == "") ?
                                                            <span className="pt-5 red-color">Name is required</span> : <></>}
                                                        {(i.Name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                            <span className="pt-5 red-color">Name is already exist</span> : <></>}
                                                    </td>
                                                    <td className="align-middle text-center border-right"><img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopupDelete(i.Id) }} /></td>
                                                </tr> : <></>
                                        ))}
                                        {this.state?.dataList?.YardData && this.state?.dataList?.YardData?.length > 0 && this.state?.dataList?.YardData?.map((i) => (
                                            i.Id == 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id="actName"
                                                            onChange={(e) => this.handleInputChange1(e, i, 'Name')}
                                                            onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                            value={i.Name}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                        {((i.Name.trim() == "" && this.state.nameError == true)) ?
                                                            <span className="pt-5 red-color">Name is required</span> : <></>}
                                                        {(i.Name.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                            <span className="pt-5 red-color">Name is already exist</span> : <></>}
                                                    </td>
                                                    <td className="align-middle text-center border-right">
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopuperror" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">{this.state.verifyText}</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => window.$("#deletepopuperror").modal("hide")}><span className="" >Ok</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.state.dataList?.pagination?.PageCount) || (this.state.dataList?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LViewYard))
);
